<template>
  <div class="content">
    <div class="bottom">
      <div class="bottomCenter">
        <div class="bottomLeft">
          <img v-lazy="require('../assets/sbd-logo.png')" alt="" @click="toHome" style="cursor: pointer" />
        </div>
        <div class="bottomBtn">
          <div class="bottomBtnTitle" style="color: #fff">快捷跳转</div>
          <div
            class="bottomBtnLi"
            v-for="(item, index) in btnArr"
            :key="index"
            @click="toDetail1(item)"
          >
            {{ item.text }}
          </div>
        </div>
        <div class="bottomRight">
          <div class="bottomBtnTitle" style="color: #fff">联系我们</div>
          <div
            class="bottomRightLi"
            v-for="(item, index) in contactUs"
            :key="index"
            v-lazy-container="{ selector: 'img' }"
          >
            <img style="width: 25px; height: 25px" :data-src="item.picUrl" alt="" />
            <div class="bottomRightText">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
      &copy; 2017-2022&nbsp;&nbsp;&nbsp;思百达物联网科技（北京）有限公司&nbsp;&nbsp;&nbsp;
      <a href="http://beian.miit.gov.cn" target="_blank">京ICP备17029803号-1</a>
      <a target="_blank" style="margin-left:10px" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502048026">
        <img style="margin-right:5px;vertical-align: middle;" v-lazy="require('../assets/keep_record_icon.png')">
        <span>京公网安备 11010502048026号</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {
      btnArr: [
        {
          text: "首页",
          url: "homecontent",
        },
        {
          text: "解决方案",
          url: "GovernmentEnterprisePark",
        },
        {
          text: "核心产品",
          url: "ProductCenter",
        },
        {
          text: "技术能力",
          url: "TechnicAlability",
        },
        {
          text: "公司介绍",
          url: "CompanyIntroduction",
        },
      ],
      contactUs: [
        {
          picUrl: require("../assets/phone.png"),
          text: "010-5913-9600",
        },
        {
          picUrl: require("../assets/email.png"),
          text: "info@sibaida.com",
        },
        {
          picUrl: require("../assets/address.png"),
          text: "北京市朝阳区西大望路甲（12号国家广告产业园） C区3号楼4层",
        },
      ],
    };
  },
  methods: {
    toHome() {
      this.$emit("changeview", 'homecontent');
      document.documentElement.scrollTop = 0;
    },
    toDetail1(e) {
      this.$emit("changeview", e.url);
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style scoped>
@media (max-width: 1200px) {
  .bottomLeft {
    width: 100%;
  }
  .bottomLeft,
  .bottomBtn,
  .bottomRight {
    flex: 1;
  }
  /* .copyright{
  line-height: 25px !important;
} */
  .bottomBtn {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .bottomLeft {
    display: none !important;
  }
}
.content {
  width: 100%;
  display: flex;
  user-select: none;
  align-items: center;
  flex-direction: column;
}
@media (min-width: 768px) {
  .bottomCenter {
    width: 800px;
  }
}
@media (min-width: 1000px) {
  .bottomCenter {
    width: 970px;
  }
}
@media (min-width: 1280px) {
  .bottomCenter {
    width: 1170px;
  }
}
.bottom {
  display: flex;
  /* height: 440px; */
  justify-content: center;
  /* margin-top: 80px; */
  background-color: #3a3a3a;
  width: 100%;
}
.bottomCenter {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;

}
.bottomLeft,
.bottomBtn,
.bottomRight {
  display: flex;
  flex-direction: column;
}
.bottomLeft {
  justify-content: center;
  align-items: center;
}
.bottomLeft > img {
  width: 226px;
  height: 60px;
}
.bottomBtn > div:nth-of-type(1) {
  margin-bottom: 20px;
}
.bottomBtn{
  margin-right: 10px;
}
.bottomBtnLi {
  width: 187px;
  height: 40px;
  line-height: 40px;
  background-color: #4e4e4e;
  font-size: 14px;
  color: #bdbdbd;
  cursor: pointer;
  text-align: center;
  margin-bottom: 20px;
}
.bottomRightLi {
  margin-top: 46px;
  display: flex;
}
.bottomRightText {
  margin-left: 13px;
  color: #8d8d8d;
  font-size: 14px;
}
.copyright {
  text-align: center;
  color: #8d8d8d;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  background-color: #333;
  box-sizing: border-box;
  width: 100%;
}
@media (max-width: 1200px) {
  .bottomBtn {
    margin-left: 20px;
  }
  .bottomRight {
    margin-right: 20px;
  }
}
@media (max-width: 425px) {
  .bottomBtnLi {
    width: auto;
    font-size: 12px;
    height: 30px;
    line-height: 30px;
  }
  .copyright {
    height: auto;
    word-wrap: break-word;
    line-height: 20px;
    font-size: 12px;
  }
  .bottomRightLi{
    margin-top: 20px;
  }
  .bottomRightText{
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue